import { ProductCard, type ProductCardData } from "./product-card";
import { PeptideProductCard, type PeptideProductCardData } from "@/ui/components/peptide";
import { ReviewsTrustWidget } from "@/ui/components/marketing/reviews-trust-widget";

export type ProductOrPeptideCard = ProductCardData | PeptideProductCardData;

function isPeptideCard(product: ProductOrPeptideCard): product is PeptideProductCardData {
	return "peptideMetadata" in product && product.peptideMetadata != null;
}

interface ProductGridProps {
	products: ProductOrPeptideCard[];
}

export function ProductGrid({ products }: ProductGridProps) {
	type Item = { kind: "product"; product: ProductOrPeptideCard; idx: number } | { kind: "reviews-widget" };

	// Interleave: alle 4 echten Produkte → 1 Dummy
	const items: Item[] = [];
	products.forEach((product, i) => {
		items.push({ kind: "product", product, idx: i });
		// Reviews-Widget direkt nach Sermorelin (Mobile-only via lg:hidden)
		if (product.slug === "sermorelin-acetate") {
			items.push({ kind: "reviews-widget" });
		}
	});

	return (
		<div className="grid w-full grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-3 lg:gap-5">
			{items.map((item, index) => {
				if (item.kind === "reviews-widget") {
					return (
						<div
							key="reviews-widget"
							className="animate-fade-in-up opacity-0 lg:hidden"
							style={{ animationDelay: `${Math.min(index * 50, 400)}ms` }}
						>
							<ReviewsTrustWidget />
						</div>
					);
				}
				return (
					<div
						key={item.product.id}
						className="animate-fade-in-up opacity-0"
						style={{ animationDelay: `${Math.min(index * 50, 400)}ms` }}
					>
						{isPeptideCard(item.product) ? (
							<PeptideProductCard product={item.product} priority={item.idx < 4} />
						) : (
							<ProductCard product={item.product} priority={item.idx < 4} />
						)}
					</div>
				);
			})}
		</div>
	);
}
